import moment from "moment";

export function getDaysInMonth(year, monthIndex) {
  const daysInMonth = moment({ year, month: monthIndex }).daysInMonth();

  return Array.from({ length: daysInMonth }, (_, i) => {
    return moment({ year, month: monthIndex, day: i + 1 }).format("DD/MM/YYYY");
  });
}

export const tableColumns = [
  {
    key: "tanggal",
    label: "",
    headerStyle: { display: "none" },
  },
  {
    key: "unitEntriHarian",
    label: "Harian",
  },
  {
    key: "unitEntriAkumulasi",
    label: "Akumulasi",
  },
  {
    key: "unitNonServisHarian",
    label: "Harian",
  },
  {
    key: "unitNonServisAkumulasi",
    label: "Akumulasi",
    cellStyle: { color: "#dc2626" },
  },
  {
    key: "unitNonServiceUePercent",
    label: "%dr UE",
    cellStyle: { color: "#dc2626" },
  },
  {
    key: "unitServiceHarian",
    label: "Harian",
  },
  {
    key: "unitServiceAkumulasi",
    label: "Akumulasi",
    cellStyle: { color: "#16a34a" },
  },
  {
    key: "unitServiceUePercent",
    label: "%dr Ue",
    cellStyle: { color: "#dc2626" },
  },
  {
    key: "totalNonKpbHarian",
    label: "Harian",
  },
  {
    key: "totalNonKpbAkumulasi",
    label: "Akumulasi",
    cellStyle: {},
  },
  {
    key: "totalNonKpbUsPercent",
    label: "%dr Us",
    cellStyle: { color: "#16a34a" },
  },
  {
    key: "totalNonKpbUePercent",
    label: "%dr Ue",
    cellStyle: { color: "#dc2626" },
  },
  {
    key: "totalKpbHarian",
    label: "Harian",
  },
  {
    key: "totalKpbAkumulasi",
    label: "Akumulasi",
    cellStyle: {},
  },
  {
    key: "totalKpbUsPercent",
    label: "%dr Us",
    cellStyle: { color: "#16a34a" },
  },
  {
    key: "totalKpbUePercent",
    label: "%dr Ue",
    cellStyle: { color: "#dc2626" },
  },
  {
    key: "kpb1Harian",
    label: "Harian",
  },
  {
    key: "kpb1Akumulasi",
    label: "Akumulasi",
    cellStyle: {},
  },
  {
    key: "kpb1TotalPercent",
    label: "%dr Tot KPB",
    cellStyle: { color: "#ca8a04" },
  },
  {
    key: "kpb2Harian",
    label: "Harian",
  },
  {
    key: "kpb2Akumulasi",
    label: "Akumulasi",
    cellStyle: {},
  },
  {
    key: "kpb2TotalPercent",
    label: "%dr Tot KPB",
    cellStyle: { color: "#ca8a04" },
  },
  {
    key: "kpb3Harian",
    label: "Harian",
  },
  {
    key: "kpb3Akumulasi",
    label: "Akumulasi",
    cellStyle: {},
  },
  {
    key: "kpb3TotalPercent",
    label: "%dr Tot KPB",
    cellStyle: { color: "#ca8a04" },
  },
];

export const groupHeaders = [
  {
    label: "Tanggal",
    colSpan: 1,
    rowSpan: 2,
    style: {
      verticalAlign: "middle",
    },
  },
  {
    label: "Unit Entri",
    colSpan: 2,
  },
  {
    label: "Unit Non Servis",
    colSpan: 3,
  },
  {
    label: "Unit Service",
    colSpan: 3,
  },
  {
    label: "Total Non KPB",
    colSpan: 4,
  },
  {
    label: "Total KPB",
    colSpan: 4,
  },
  {
    label: "KPB 1",
    colSpan: 3,
  },
  {
    label: "KPB 2",
    colSpan: 3,
  },
  {
    label: "KPB 3",
    colSpan: 3,
  },
];

export const generatePayloadPrint = (data) => ({
  filename: "Laporan_Service_Harian_By_Cabang",
  sheets: [
    {
      name: "Report",
      headers: [
        {
          key: "tanggal",
          title: "Tanggal",
        },
        {
          title: "Unit Entri",
          children: [
            {
              key: "unitEntriHarian",
              title: "Harian",
            },
            {
              key: "unitEntriAkumulasi",
              title: "Akumulasi",
            },
          ],
        },
        {
          title: "Unit Non Servis",
          children: [
            {
              key: "unitNonServisHarian",
              title: "Harian",
            },
            {
              key: "unitNonServisAkumulasi",
              title: "Akumulasi",
            },
            {
              key: "unitNonServiceUePercent",
              title: "%dr UE",
            },
          ],
        },
        {
          title: "Unit Service",
          children: [
            {
              key: "unitServiceHarian",
              title: "Harian",
            },
            {
              key: "unitServiceAkumulasi",
              title: "Akumulasi",
            },
            {
              key: "unitServiceUePercent",
              title: "%dr Ue",
            },
          ],
        },
        {
          title: "Total Non KPB",
          children: [
            {
              key: "totalNonKpbHarian",
              title: "Harian",
            },
            {
              key: "totalNonKpbAkumulasi",
              title: "Akumulasi",
            },
            {
              key: "totalNonKpbUsPercent",
              title: "%dr Us",
            },
            {
              key: "totalNonKpbUePercent",
              title: "%dr Ue",
            },
          ],
        },
        {
          title: "Total KPB",
          children: [
            {
              key: "totalKpbHarian",
              title: "Harian",
            },
            {
              key: "totalKpbAkumulasi",
              title: "Akumulasi",
            },
            {
              key: "totalKpbUsPercent",
              title: "%dr Us",
            },
            {
              key: "totalKpbUePercent",
              title: "%dr Ue",
            },
          ],
        },
        {
          title: "KPB 1",
          children: [
            {
              key: "kpb1Harian",
              title: "Harian",
            },
            {
              key: "kpb1Akumulasi",
              title: "Akumulasi",
            },
            {
              key: "kpb1TotalPercent",
              title: "%dr Tot KPB",
            },
          ],
        },
        {
          title: "KPB 2",
          children: [
            {
              key: "kpb2Harian",
              title: "Harian",
            },
            {
              key: "kpb2Akumulasi",
              title: "Akumulasi",
            },
            {
              key: "kpb2TotalPercent",
              title: "%dr Tot KPB",
            },
          ],
        },
        {
          title: "KPB 3",
          children: [
            {
              key: "kpb3Harian",
              title: "Harian",
            },
            {
              key: "kpb3Akumulasi",
              title: "Akumulasi",
            },
            {
              key: "kpb3TotalPercent",
              title: "%dr Tot KPB",
            },
          ],
        },
      ],
      data: data,
    },
  ],
});
